import React from "react";
import classes from "./information.module.scss";
import PropTypes from "prop-types";

function Information(props) {
  return (
    <div className={classes.inform}>
      <div className={classes.img__wrapper}>
        <img className={classes.img} src={props.src} alt="river" />
      </div>
      <div className={classes.title}>
        <h2>{props.name}</h2>
        <p>{props.informMiddle}</p>
      </div>
    </div>
  );
}

Information.propTypes = {
  src: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  inform: PropTypes.string.isRequired,
};

export default Information;
